// extracted by css-extract-rspack-plugin
export default {"addProjectsCTA":"oJkn6o2S4DUu2VBT","message":"HLG0iMWm9toifW96"};